import { fieldIsVulcanOrder, fieldSalesRepInfo } from '../../utils/constant';
import { getFieldValue } from '../utils';

const PrequalificationHelpers = ({
  isCreateOrderButtonVisible,
  formFields,
  fieldName
}) => {
  const isVulcanOrder = getFieldValue(fieldIsVulcanOrder, formFields);

  if (fieldName === fieldSalesRepInfo) {
    return true;
  }

  if (fieldName === fieldIsVulcanOrder && !isVulcanOrder) {
    isCreateOrderButtonVisible(true);
  }

  if (fieldName === fieldIsVulcanOrder && isVulcanOrder === 'Yes') {
    isCreateOrderButtonVisible(false);
  } else if (fieldName === fieldIsVulcanOrder && isVulcanOrder === 'No') {
    isCreateOrderButtonVisible(true);
  }
};

export default PrequalificationHelpers;
